angular.module('app')
    .directive('animatedLogoSlogan', animatedLogoSlogan)

animatedLogoSlogan.$inject = [];
function animatedLogoSlogan() {
    return {
        restrict: 'EA',
        link: link,
        template: ''
    };

    function link(scope, element, attrs) {
        var container = $(element);
        var logoImg = container.find('.logo-image-container');
        var logoSlogan = container.find('.logo-slogan');

        var tweenLogoSlogan = new TimelineMax()
            .to(logoImg, 1, { startAt: { scale: 0 }, scale: 1, opacity: 1, ease: Bounce.easeInOut })
            .to(logoSlogan, 2, { startAt: { scale: 3 }, scale: 1, opacity: 1, ease: Power2.easeInOut }, '-=0.75')

        var scrollMagicLogoSlogan = new ScrollMagic.Controller();
        var firstScene = new ScrollMagic.Scene(
                    {
                        offset: logoImg.offset().top + 500, //hack since triggerElement is not able to detect .grid-area
                        reverse: true
                    })
                    .setTween(tweenLogoSlogan)
                    //.addIndicators('.grid-area')
                    .addTo(scrollMagicLogoSlogan);
    }
}